import { el } from './dom';

/** Developer overlay showing the state that matters while tuning the movement. */
export class DebugOverlay {
  readonly root = el('pre', 'debug hidden');

  constructor(parent: HTMLElement) {
    parent.append(this.root);
  }

  setVisible(visible: boolean): void {
    this.root.classList.toggle('hidden', !visible);
  }

  get isVisible(): boolean {
    return !this.root.classList.contains('hidden');
  }

  update(lines: string[]): void {
    this.root.textContent = lines.join('\n');
  }
}
